export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23')
];

export const server_loads = [];

export const dictionary = {
		"/": [3],
		"/about": [4],
		"/admin": [5,[2]],
		"/admin/admins": [6,[2]],
		"/admin/canceled": [7,[2]],
		"/admin/customers": [8,[2]],
		"/admin/customers/[phone]": [9,[2]],
		"/admin/delivered": [10,[2]],
		"/admin/hosting-balance": [11,[2]],
		"/admin/login": [12,[2]],
		"/admin/notifications-test": [13,[2]],
		"/admin/orders": [14,[2]],
		"/admin/orders/[id]": [15,[2]],
		"/admin/products": [16,[2]],
		"/cart": [17],
		"/debug-notifications": [18],
		"/orders": [19],
		"/orders/[id]": [20],
		"/products": [21],
		"/profile": [22],
		"/test-notifications": [23]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.svelte';